/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ButtonComponent, classNames } from '@syncfusion/ej2-react-buttons';
import { format, parseISO } from 'date-fns';
import {
  Legend,
  SeriesCollectionDirective,
  ChartComponent,
  SeriesDirective,
  DateTime,
  LineSeries,
  Export,
  Inject,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  PieSeries,
  AccumulationChartComponent,
} from '@syncfusion/ej2-react-charts';
import {
  CircularGaugeComponent,
  AxesDirective,
  AxisDirective,
  PointersDirective,
  PointerDirective,
} from '@syncfusion/ej2-react-circulargauge';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { DataManager, Query } from '@syncfusion/ej2-data';

import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter,
  ColumnChooser,
  Resize,
} from '@syncfusion/ej2-react-grids';

import { useNavigate } from 'react-router-dom';
import { AMap, Header } from '../components';
import { useStateContext } from '../contexts/ContextProvider';
import { statsWorkResteGrid, calculateAge } from '../data/dummy';
import armband from '../data/watchsketch.png';

import './Zackat.css';

const Stats = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=notificationevents');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { zRenderMode, isMobile, setNotificationDevice } = useStateContext();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [data, setData] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [associates, setAssociates] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [heartrates, setHeartRates] = useState([]);
  const [temperatures, setTemperatures] = useState([]);
  const [numActive, setNumActive] = useState(0);
  const [selOrganization, setOrganization] = useState('');
  const [selTitle, setTitle] = useState('');
  const [exposureData, setExposureData] = useState([]);
  const [selFrequency, setFrequency] = useState('na');
  const [loading, setLoading] = useState(true);
  const [workrestLoaded, setWorkRest] = useState(false);
  const [associateCount, setAssociateCount] = useState(0);
  const [inventoryCount, setInventoryCount] = useState(0);
  const [managerCount, setManagerCount] = useState(0);
  const [mgrData, setMgrData] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [associate, setAssociate] = useState(null);
  const grid = useRef(null);
  const frequency = [
    { value: 'na', text: 'Not Specified' },
    { value: 'day', text: 'Day' },
    { value: 'week', text: 'Week' },
    { value: 'month', text: 'Month' },
  ];
  const scoreCard = [
    { _id: '0', score: '-1', desc: '🥏 HYPO', action: 'Caution advised' },
    { _id: '1', score: '0-25', desc: '✅ BASELINE', action: 'Continue monitoring' },
    { _id: '2', score: '25-50', desc: '💗 MODERATE', action: 'Hydrate, increase rest breaks' },
    { _id: '3', score: '50-80', desc: '🌡 ELEVATED', action: 'Manager intervention, rest, hydrate' },
    { _id: '4', score: '80-', desc: '🚓 SEVERE', action: 'Stop work, cool down, medical evaluation' },
  ];
  const chartData = [
    { x: 'Core Temperature', y: 0.35 },
    { x: 'Heart Rate', y: 0.25 },
    { x: 'Rate of Temperature increase', y: 0.15 },
    { x: 'Heart Rate recovery', y: 0.10 },
    { x: 'Time in heat', y: 0.10 },
    { x: 'GPS isolation', y: 0.05 },
  ];
    // Sample data: percentage of goal met for each metric (0 to 100)
  const [movePercentage, setMovePercentage] = useState(85); // Red ring
  const [exercisePercentage, setExercisePercentage] = useState(65); // Green ring
  const [standPercentage, setStandPercentage] = useState(45); // Cyan ring
  const legendItems = [
    { label: 'Risk', color: '#fa114f', value: `${movePercentage}%` },
    { label: 'Activity', color: '#00ff66', value: `${exercisePercentage}%` },
    { label: 'Environment', color: '#00f0ff', value: `${standPercentage}%` },
  ];

  const boxPad = isMobile ? '16px' : '24px';
  const boxFont = isMobile ? '1rem' : '1.25rem';
  const chartHeight = isMobile ? '280px' : '450px';
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
    gap: isMobile ? '12px' : '16px',
    padding: isMobile ? '12px' : '16px',
  };

  const boxStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    padding: boxPad,
    textAlign: 'center',
    borderRadius: '8px',
    fontSize: boxFont,
    minWidth: 0,
  };
  const lboxStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    padding: boxPad,
    textAlign: 'left',
    borderRadius: '8px',
    fontSize: boxFont,
    minWidth: 0,
  };
  const llboxStyle = {
    backgroundColor: '#0000001f',
    color: 'black',
    padding: boxPad,
    textAlign: 'left',
    borderRadius: '8px',
    fontSize: boxFont,
    minWidth: 0,
  };
  const mapStyle = {
    backgroundColor: '#F6821E7f',
    color: 'black',
    width: '100%',
    padding: boxPad,
    textAlign: 'left',
    borderRadius: '8px',
    fontSize: boxFont,
    minWidth: 0,
  };
  const orgStyle = {
    backgroundColor: 'white',
    color: 'black',
    padding: boxPad,
    textAlign: 'center',
    borderRadius: '8px',
    fontSize: boxFont,
    minWidth: 0,
  };
  const wrapAdaptiveGrid = (gridEl) => {
    if (!gridEl) {
      return null;
    }
    return (
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            {gridEl}
          </div>
        </div>
      </div>
    );
  };
  const pageSettings = { pageSize: 8 };
  function formatPhoneNumber(phoneNumberString) {
    if (!phoneNumberString || phoneNumberString.length <= 0) {
      return null;
    }
    if (phoneNumberString && phoneNumberString.length === 10) {
      phoneNumberString = `1${phoneNumberString}`;
    }
    const cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }
  const formatElapsedHms = (ms) => {
    const totalMs = Number(ms);
    if (!Number.isFinite(totalMs) || totalMs < 0) {
      return '';
    }
    const totalSeconds = Math.floor(totalMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };
  const avgElapsedHmsAccessor = (_field, r) => formatElapsedHms(r && r.avgElapsedMs);

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      setLoading(true);
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      if (mydata) {
        // set state when the data received
        setData(mydata);
        setOrgs(mydata.organization);
        setLoading(false);
      }
    };
    dataFetch();
  }, []);
  useEffect(() => {
    const fetchCount = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      setAssociate(null);
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?count=true&${query}&specific=true`;
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      setAssociateCount(mydata.associateCount);
      setInventoryCount(mydata.inventoryCount);
      setManagerCount(mydata.managerCount);
    };
    fetchCount();
    return () => {
      setAssociateCount(0);
      setInventoryCount(0);
      setManagerCount(0);
      setNumActive(0);
      setTitle('');
    };
  }, [selOrganization]);
  useEffect(() => {
    const getManagerData = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&orgid=${selOrganization}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let mymgr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((m) => {
              m.name = `${m.first} ${m.last}`;
            });
            mymgr = mydata;
          }
          setMgrData(mymgr);
        })
        .catch((error) => {
          setMgrData([]);
        });
    };
    getManagerData();
  }, [selOrganization]);

  useEffect(() => {
    usr.organizationid = 'na';
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    const associateFetch = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      setLoading(true);
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?${query}&limit=0&specific=true`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          if (!mydata.associates) {
            setAssociates([]);
          } else {
            const myassociates = [];
            let freq = 86400;
            switch (selFrequency) {
              case 'day':
                freq = 86400;
                break;
              case 'week':
                freq = 7 * 86400;
                break;
              case 'month':
                freq = 30 * 86400;
                break;
              default:
                freq = 1 * 86400;
                break;
            }
            const dt = new Date();
            mydata.associates.forEach((a) => {
              setTitle(a.organization);
              const at = new Date(a.timestamp);
              if (at && (at.getTime() / 1000).toFixed(0) >= (dt.getTime() / 1000).toFixed() - freq) {
                myassociates.push(a);
              }
            });
            // setAssociates(mydata.associates);
            setAssociates(myassociates);
            let num = 0;
            mydata.associates.forEach((a) => {
              if (a.device && a.device.length > 0) {
                num += 1;
              }
            });
            setNumActive(num);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
      setLoading(false);
    };
    associateFetch();
  }, [selOrganization, selFrequency]);
  useEffect(() => {
    const workFetch = async () => {
      usr.organizationid = selOrganization;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      setExposureData([]);

      const to = new Date();
      const from = new Date();
      let freq = 1;
      switch (selFrequency) {
        case 'day':
          freq = 1;
          break;
        case 'week':
          freq = 7;
          break;
        case 'month':
          freq = 30;
          break;
        default:
          freq = 1;
          break;
      }

      from.setDate(from.getDate() - freq);
      const f = (from.getTime() / 1000).toFixed(0);
      setWorkRest(false);
      const url = `${REACT_APP_API_ENDPOINT}/reports?report=workrest&${query}&from=${f}&to=${(to.getTime() / 1000).toFixed(0)}&specific=true`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.workrest) {
            setExposureData(response.workrest);
          } else {
            setExposureData([]);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
      setWorkRest(true);
    };
    workFetch();
  }, [selOrganization, selFrequency]);
  useEffect(() => {
    usr.organizationid = 'na';
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }

    const vitalFetch = async () => {
      if (!selOrganization || selOrganization.length === 0) {
        return;
      }
      usr.organizationid = selOrganization;
      usr.frequency = selFrequency;
      setHeartRates([]);
      setTemperatures([]);
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      let url = `${REACT_APP_API_ENDPOINT}/reports?report=hrEvents&${query}`;

      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          const myhr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((a) => {
              const myDate = new Date(a.Year, a.Month - 1, a.Day);
              // const newrec = [];
              myhr.push({
                title: a.Name,
                x: myDate,
                y: a.AvgValue,
              });
              // myhr.push(newrec);
            });
            // Group data by 'title'
            const groupedData = myhr.reduce((acc, item) => {
              if (!acc[item.title]) {
                acc[item.title] = [];
              }
              acc[item.title].push(item);
              return acc;
            }, {});
            setHeartRates(groupedData);
          } else {
            setHeartRates([]);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
      url = `${REACT_APP_API_ENDPOINT}/reports?report=tempEvents&${query}`;

      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          const myhr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((a) => {
              const myDate = new Date(a.Year, a.Month - 1, a.Day);
              myhr.push({
                title: a.Name,
                x: myDate,
                y: a.AvgValue,
              });
            });
            // Group data by 'title'
            const groupedData = myhr.reduce((acc, item) => {
              if (!acc[item.title]) {
                acc[item.title] = [];
              }
              acc[item.title].push(item);
              return acc;
            }, {});
            setTemperatures(groupedData);
          } else {
            setTemperatures([]);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
    };
    vitalFetch();
  }, [selOrganization, selFrequency]);
  useEffect(() => {
    // fetch data
    const dataFetch = async () => {
      // limit associates to the overall selection
      setAlerts([]);
      usr.limit = '100';
      usr.specific = true;
      usr.organizationid = selOrganization;
      const to = new Date();
      const from = new Date();
      let freq = 1;
      switch (selFrequency) {
        case 'day':
          freq = 1;
          break;
        case 'week':
          freq = 7;
          break;
        case 'month':
          freq = 30;
          break;
        default:
          freq = 1;
          break;
      }

      from.setDate(from.getDate() - freq);
      const f = (from.getTime() / 1000).toFixed(0);
      setReasons([]);
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/notifications?${query}&from=${f}&to=${(to.getTime() / 1000).toFixed(0)}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // set state when the data received
          setAlerts(mydata);
          setReasons(mydata.results.ackByReason);
        })
        .catch((error) => {
          console.error(error.message);
        });
    };
    dataFetch();
  }, [selOrganization]);
  useEffect(() => {
    // limit associates to the overall selection
    usr.organizationid = selOrganization;
    // fetch data
    const dataFetch = async () => {
      try {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/jobs?${query}`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json()
          .catch((err) => {
            console.error('Error parsing JSON:', err);
            return null;
          });
        setJobs(mydata.jobs);
      } catch (err) {
        setJobs([]);
      }
    };
    // set state when the data received
    dataFetch();
  }, [selOrganization]); // mapDisplay

  const organizations = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(orgs),
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };

  if (loading) {
    return <p>Loading... </p>;
  }
  return (
    <div className={!isMobile ? 'm-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh max-w-full overflow-x-hidden' : 'bg-white rounded-3xl zackat-divalh w-full mt-44 max-w-full overflow-x-hidden'}>
      <Header category="Administration" title={selTitle ? `Organization Statistics: ${selTitle}` : 'Organization Statistics'} />
      <div style={containerStyle}>
        <div style={lboxStyle}> <img src={armband} width={35} height={30} /> {inventoryCount} (Number of W<sup>3</sup> Devices)</div>
        <div style={lboxStyle}> 👫 {managerCount} (Number of Active W<sup>3</sup> Managers)</div>
        <div style={lboxStyle}> 🕺 {numActive} (Number of Associates assigned to W<sup>3</sup> Devices)</div>
        <div style={lboxStyle}> 👥 {associateCount} (Number of W<sup>3</sup> Associates)</div>
        <div style={orgStyle}>
          <DropDownListComponent
            id="ddlelement"
            floatLabelType="Auto"
            cssClass="e-outline"
            dataSource={organizations.params.dataSource}
            fields={organizations.params.fields}
            placeholder="Select Organization"
            sortOrder="Ascending"
            // enabled={false} // Disables the entire component
            value={selOrganization}
            change={(v) => { setOrganization(v.value); }}
          />
        </div>
        <div style={orgStyle}>
          <DropDownListComponent
            id="ddlelement"
            floatLabelType="Auto"
            cssClass="e-outline"
            dataSource={frequency}
            fields={{ value: 'value', text: 'text' }}
            placeholder="Select Frequency"
            // enabled={false} // Disables the entire component
            value={selFrequency}
            change={(v) => { setFrequency(v.value); }}
          />
        </div>
        {selOrganization && selOrganization.length > 0 && (
        <div style={boxStyle}>
          <h2>WORKER STATUS</h2>
          {wrapAdaptiveGrid(
            <GridComponent
              dataSource={associates}
              allowPaging
              pageSettings={pageSettings}
              allowTextWrap
              allowSorting
              allowFiltering
              width="100%"
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              rowSelected={(e) => {
                setMovePercentage(e.data.risk ? ((e.data.risk / 100) * 100).toFixed(0) : 0);
                setExercisePercentage(e.data.activity.reading ? ((e.data.activity.reading / 5000) * 100).toFixed(0) : 0);
                setStandPercentage(0);
                const job = jobs.find((j) => j.title === e.data.latlng.location);
                if (job?.forecast?.forecastDays?.length > 0) {
                  if (job.forecast.forecastDays[0].feelsLikeMaxTemperature.unit === 'CELSIUS') {
                    setStandPercentage(((job.forecast.forecastDays[0].feelsLikeMaxTemperature.degrees / 38) * 100).toFixed(0));
                  } else {
                    setStandPercentage(((job.forecast.forecastDays[0].feelsLikeMaxTemperature.degrees / 100) * 100).toFixed(0));
                  }
                }
                setAssociate(e.data);
              }}
            >
              <ColumnsDirective>
                <ColumnDirective field="_id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
                <ColumnDirective field="name" headerText="Worker" width="120" textAlign="Left" />
                <ColumnDirective field="heartrate.reading" headerText="Heart Rate (bpm)" width="100" textAlign="Left" />
                <ColumnDirective field="temperature.reading" headerText="Core Temp °F" width="100" textAlign="Left" />
                <ColumnDirective field="latlng.location" headerText="GPS Location" width="100" textAlign="Left" visible={!isMobile} />
                <ColumnDirective field="exposuretime" headerText="Exposure time" width="120" textAlign="Left" />
                <ColumnDirective field="risk" headerText="Risk Score" width="100" textAlign="Left" />
                <ColumnDirective field="jobtask" headerText="Job Task" width="100" textAlign="Left" visible={!isMobile} />
                <ColumnDirective field="action" headerText="Action" width="150" textAlign="Left" />
              </ColumnsDirective>

              {/* Inject features into the grid dynamically */}
              <Inject services={[Page, Sort, Filter]} />
            </GridComponent>,
          )}
          {associate && (
          <div style={containerStyle}>
            <div style={{
              backgroundColor: '#0000001f',
              padding: '2px',
              borderRadius: '4px',
              width: '100%',
              textAlign: 'center',
            }}
            >
              <h2>{associate.name}</h2>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: 240, height: 240, pointerEvents: 'none' }}>
                  <CircularGaugeComponent
                    id="worker-status-gauge"
                    key={associate._id}
                    background="transparent"
                    width="240px"
                    height="240px"
                    enableRtl={false}
                    enablePointerDrag={false}
                    tooltip={{ enable: false }}
                  >
                    <AxesDirective>
                      <AxisDirective
                        startAngle={0}
                        endAngle={360}
                        minimum={0}
                        maximum={100}
            // Hide standard gauge details to mimic standard rings
                        lineStyle={{ width: 0 }}
                        majorTicks={{ width: 0 }}
                        minorTicks={{ width: 0 }}
                        labelStyle={{ font: { size: '0px' } }}
                      >
                        <PointersDirective>
                          {/* === MOVE RING (OUTER) === */}
                          {/* Outer Track Background */}
                          <PointerDirective
                            value={100}
                            type="RangeBar"
                            radius="100%"
                            color="rgba(255, 0, 51, 0.15)"
                            pointerWidth={16}
                          />
                          {/* Outer Active Progress */}
                          <PointerDirective
                            value={movePercentage}
                            type="RangeBar"
                            radius="100%"
                            color="#fa114f"
                            pointerWidth={16}
                            roundedCornerRadius={8}
                            animation={{ enable: true, duration: 1000 }}
                          />

                          {/* === EXERCISE RING (MIDDLE) === */}
                          {/* Middle Track Background */}
                          <PointerDirective
                            value={100}
                            type="RangeBar"
                            radius="82%"
                            color="rgba(0, 255, 102, 0.15)"
                            pointerWidth={16}
                          />
                          {/* Middle Active Progress */}
                          <PointerDirective
                            value={movePercentage}
                            type="RangeBar"
                            radius="82%"
                            color="#00ff66"
                            pointerWidth={16}
                            roundedCornerRadius={8}
                            animation={{ enable: true, duration: 1200 }}
                          />

                          {/* === STAND RING (INNER) === */}
                          {/* Inner Track Background */}
                          <PointerDirective
                            value={100}
                            type="RangeBar"
                            radius="64%"
                            color="rgba(0, 240, 255, 0.15)"
                            pointerWidth={16}
                          />
                          {/* Inner Active Progress */}
                          <PointerDirective
                            value={standPercentage}
                            type="RangeBar"
                            radius="64%"
                            color="#00f0ff"
                            pointerWidth={16}
                            roundedCornerRadius={8}
                            animation={{ enable: true, duration: 1400 }}
                          />
                        </PointersDirective>
                      </AxisDirective>
                    </AxesDirective>
                  </CircularGaugeComponent>
                </div>
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'space-around',
                marginTop: '16px',
                borderTop: '1px solid #222',
                paddingTop: '16px',
              }}
              >
                {legendItems.map((item, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* Colored Ring Dot */}
                    <span style={{
                      width: '10px',
                      height: '10px',
                      borderRadius: '50%',
                      backgroundColor: item.color,
                      display: 'inline-block',
                    }}
                    />
                    {/* Label and Value */}
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
                      <span style={{ color: item.color, fontWeight: 'bold', fontSize: '12px' }}>{item.label}</span>
                      <span style={{ color: '#ffffff', fontSize: '15px', fontWeight: 'bold' }}>{item.value}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={llboxStyle}>
              {associate.dob ? <p>Date of Birth: {calculateAge(associate.dob)} years old</p> : <p>Date of Birth: N/A</p>}
              {associate.gender ? <p>Gender: {associate.gender.toUpperCase()} </p> : <p>Gender: N/A</p>}
              {associate.mobile ? <p>Mobile: {associate.mobile} </p> : <p>Mobile: N/A</p>}
              {associate.email ? <p>EMAIL: {associate.email.toLowerCase()} </p> : <p>EMAIL: N/A</p>}
            </div>
          </div>
          )}
        </div>
        )}
        {!isMobile && selOrganization && selOrganization.length > 0 && (
          <div style={mapStyle}>
            <h2>LIVE WORKER MAP</h2>
            <div className={`mt-10${isMobile ? ' stats-map-mobile' : ''}`}>
              <AMap active org={selOrganization} />
            </div>
          </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
          <div style={boxStyle}><h1> 🛎 (Active SEVERE Risk)</h1>
            {associates.map((a) => (
              a.risk >= 80 && (
                <div style={containerStyle} key={`asr_${a._id}`}>
                  {a.risk >= 80 && (
                    <>
                      <div style={lboxStyle}>
                        <h1>SEVERE: {a.name}</h1>
                        Core Temperature {a.temperature.reading || ''}<br />
                        Heart Rate {a.heartrate.reading || ''}<br />
                        Location {a.latlng.location || ''}<br />
                        Last Activity/Movement {a.activity && a.activity.timestamp ? parseISO(a.activity.timestamp).toLocaleString('en-US', {
                          month: 'short', // Options: 'numeric', '2-digit', 'long', 'short', 'narrow'
                          day: 'numeric', // Options: 'numeric', '2-digit'
                          hour: '2-digit', // Options: 'numeric', '2-digit'
                          minute: '2-digit', // Options: 'numeric', '2-digit'
                          hour12: true, // Enables AM/PM format
                        }) : ''}

                      </div>
                      <div style={lboxStyle}>
                        Dispatch nearest responder
                        {orgs.map((o, index) => {
                          if (o._id === a.organizationid) {
                            return (
                              <p key={index}>
                                <b>Contact Corportate {o.title} {formatPhoneNumber(o.phone)}</b>
                              </p>
                            );
                          }
                          return null;
                        })}
                        Contact Manager(s)
                        {a.managers
                          .filter((m) => m && m.length !== 0)
                          .map((m, index) => {
                            const result = mgrData.find(({ _id }) => _id === m);
                            if (!result) return null;
                            return (
                              <p key={index}>
                                {result.first} {result.last} {formatPhoneNumber(result.mobile)}
                              </p>
                            );
                          })}
                      </div>
                    </>
                  )}
                </div>
              )
            ))}
          </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
          <div style={boxStyle}><h1>⚠ (Active ELEVATED Risk)</h1>
            {associates
              .filter((a) => a.risk >= 50)
              .map((a, index) => (
                <div style={containerStyle} key={index}>
                  {a.risk < 80 && (
                    <>
                      <div style={lboxStyle}>
                        <h1>ELEVATED: {a.name}</h1>
                        Core Temperature {a.temperature.reading || ''}<br />
                        Heart Rate {a.heartrate.reading || ''}<br />
                        Location {a.latlng.location || ''}<br />
                        Last Movement {a.activity && a.activity.timestamp ? format(parseISO(a.activity.timestamp), 'hh:mm') : ''}
                      </div>
                      <div style={lboxStyle}>
                        Mandatory rest
                        Hydrate
                        Contact Manager(s)
                        {a.managers
                          .filter((m) => m && m.length !== 0)
                          .map((m) => {
                            const result = mgrData.find(({ _id }) => _id === m);
                            if (!result) return null;
                            return (
                              <p key={m}>
                                {result.first} {result.last} {formatPhoneNumber(result.mobile)} email {result.email}
                              </p>
                            );
                          })}
                      </div>
                    </>
                  )}
                </div>
              ))}
          </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
          <div style={boxStyle}> 💹 (Physiological Trends)
            <div style={containerStyle}>
              <div style={boxStyle}>HeartRate
                <ChartComponent
                  id="hrChart"
                  // ref={(trafficChart) => { traffic1 = trafficChart; }}
                  style={{ textAlign: 'center' }}
                  width="100%"
                  height={chartHeight}
                  // load={Chartload}
                  legendSettings={{ visible: true }}
                  primaryXAxis={{ valueType: 'DateTime', labelFormat: 'M/y', labelRotation: -45, majorGridLines: { width: 0 }, intervalType: 'Months', edgeLabelPlacement: 'Shift' }}
                  primaryYAxis={{ labelFormat: '{value}', lineStyle: { width: 0 }, maximum: 160, interval: 10, majorTickLines: { width: 0 }, minorTickLines: { width: 0 } }}
                  chartArea={{ border: { width: 0 } }}
                >
                  <Inject services={[LineSeries, DateTime, Legend, Export]} />
                  <SeriesCollectionDirective>
                    {Object.keys(heartrates).map((name) => (
                      <SeriesDirective
                        key={name}
                        xName="x"
                        dataSource={heartrates[name]}
                        yName="y"
                        name={name}
                        type="Line"
                        width={2}
                        marker={{ visible: true }}
                      />
                    ))}
                  </SeriesCollectionDirective>
                </ChartComponent>
              </div>
              <div style={boxStyle}>Temperature
                <ChartComponent
                  id="tempChart"
                  // ref={(trafficChart) => { traffic1 = trafficChart; }}
                  style={{ textAlign: 'center' }}
                  width="100%"
                  height={chartHeight}
                  // load={Chartload}
                  legendSettings={{ visible: true }}
                  primaryXAxis={{ valueType: 'DateTime', labelFormat: 'M/y', labelRotation: -45, majorGridLines: { width: 0 }, intervalType: 'Months', edgeLabelPlacement: 'Shift' }}
                  primaryYAxis={{ labelFormat: '{value}', lineStyle: { width: 0 }, maximum: 160, interval: 10, majorTickLines: { width: 0 }, minorTickLines: { width: 0 } }}
                  chartArea={{ border: { width: 0 } }}
                >
                  <SeriesCollectionDirective>
                    {Object.keys(temperatures).map((name) => (
                      <SeriesDirective
                        key={name}
                        xName="x"
                        dataSource={temperatures[name]}
                        yName="y"
                        name={name}
                        type="Line"
                        width={2}
                        marker={{ visible: true }}
                      />
                    ))}
                    <Inject services={[LineSeries, DateTime, Legend, Export]} />
                  </SeriesCollectionDirective>
                </ChartComponent>
              </div>
            </div>
          </div>
        )}
        {selOrganization && selOrganization.length > 0 && workrestLoaded && (
          <div style={boxStyle}> 💪 (Exposure Summary)
            <div style={{ width: '100%' /* or any parent width */ }}>
              {wrapAdaptiveGrid(
                <GridComponent
                  dataSource={exposureData}
                  allowPaging
                  pageSettings={pageSettings}
                  allowTextWrap
                  allowSorting
                  width="100%"
                  allowFiltering
                  reg={grid}
                  enableAdaptiveUI={isMobile}
                  rowRenderingMode={zRenderMode}
                >
                  <ColumnsDirective>
                    {statsWorkResteGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                  </ColumnsDirective>
                  {/* Inject features into the grid dynamically */}
                  <Inject services={[Page, Sort, Filter]} />
                </GridComponent>,
              )}
            </div>
          </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
          <div style={boxStyle}>
            <h1>🌝 (Location Risk Analysis))</h1>
            {wrapAdaptiveGrid(
              <GridComponent
                dataSource={jobs}
                allowPaging
                pageSettings={pageSettings}
                allowTextWrap
                allowSorting
                allowFiltering
                width="100%"
                enableAdaptiveUI={isMobile}
                rowRenderingMode={zRenderMode}
              >
                <ColumnsDirective>
                  <ColumnDirective field="Id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
                  <ColumnDirective field="title" headerText="Title" width="100" textAlign="Left" />
                  <ColumnDirective field="description" headerText="Description" width="150" textAlign="Left" />
                  <ColumnDirective field="manager" headerText="Manager" width="120" textAlign="Left" />
                  <ColumnDirective field="aqi.hourlyForecasts.0.indexes.0.aqi" headerText="Air Quality" width="120" textAlign="Left" />
                  <ColumnDirective field="aqi.hourlyForecasts.0.indexes.0.category" headerText="Air Category" width="120" textAlign="Left" />
                  <ColumnDirective field="forecast.forecastDays.0.feelsLikeMaxTemperature.degrees" headerText="Heat Index" width="120" textAlign="Left" />
                  <ColumnDirective field="forecast.forecastDays.0.feelsLikeMaxTemperature.unit" headerText="Scale" width="120" textAlign="Left" visible={!isMobile} />
                </ColumnsDirective>
                {/* Inject features into the grid dynamically */}
                <Inject services={[Page, Sort, Filter]} />
              </GridComponent>,
            )}
          </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
        <div style={containerStyle}>
          <div style={boxStyle}>
            <h1>👹 (Alert History)</h1>
            {isMobile ? (
              <>
                <p>{alerts.results && alerts.results.totalNotifications && alerts.results.totalNotifications.toLocaleString('en-US')} 🛎 (safety notifications for {new Date().getFullYear()})</p>
                <p>{alerts.results && alerts.results.ackNotifications && alerts.results.totalNotifications && ((alerts.results.totalHeat / alerts.results.totalNotifications) * 100).toFixed(0)}% ⚠ (heat related stress events)</p>
                <p>{alerts.results && alerts.results.ackNotifications && alerts.results.totalNotifications && ((alerts.results.ackNotifications / alerts.results.totalNotifications) * 100).toFixed(0)}% &#x2406; (intervention acknowledgement rate)</p>
                <p>{alerts.results && alerts.results.totalEvents && alerts.results.totalEvents.toLocaleString('en-US')} ⌖ (environmental sensor readings collected)</p>
              </>
            ) : (
              <>
                <h1>{alerts.results && alerts.results.totalNotifications && alerts.results.totalNotifications.toLocaleString('en-US')} 🛎 (safety notifications for {new Date().getFullYear()})
                  <br /> {alerts.results && alerts.results.ackNotifications && alerts.results.totalNotifications && ((alerts.results.totalHeat / alerts.results.totalNotifications) * 100).toFixed(0)}% ⚠ (heat related stress events)
                </h1>
                <h1>{alerts.results && alerts.results.ackNotifications && alerts.results.totalNotifications && ((alerts.results.ackNotifications / alerts.results.totalNotifications) * 100).toFixed(0)}% &#x2406; (intervention acknowledgement rate)
                  <br /> {alerts.results && alerts.results.totalEvents && alerts.results.totalEvents.toLocaleString('en-US')} ⌖ (environmental sensor readings collected)
                </h1>
              </>
            )}
            {wrapAdaptiveGrid(
              <GridComponent
                dataSource={alerts.notifications}
                allowPaging
                pageSettings={pageSettings}
                allowTextWrap
                allowSorting
                width="100%"
                enableAdaptiveUI={isMobile}
                rowRenderingMode={zRenderMode}
              >
                <ColumnsDirective>
                  <ColumnDirective field="_id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
                  <ColumnDirective field="time" headerText="Time" width="100" textAlign="Left" />
                  <ColumnDirective field="name" headerText="Worker" width="120" textAlign="Left" />
                  <ColumnDirective field="desc" headerText="Event" width="150" textAlign="Left" />
                </ColumnsDirective>
                {/* Inject features into the grid dynamically */}
                <Inject services={[Page, Sort, Filter]} />
              </GridComponent>,
            )}
          </div>
          <div style={boxStyle}>
            <h1>👹 (Response Performance)</h1>
            {wrapAdaptiveGrid(
              <GridComponent
                dataSource={reasons}
                allowPaging
                pageSettings={pageSettings}
                allowTextWrap
                allowSorting
                width="100%"
                enableAdaptiveUI={isMobile}
                rowRenderingMode={zRenderMode}
              >
                <ColumnsDirective>
                  <ColumnDirective field="_id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
                  <ColumnDirective field="reason" headerText="Reason" width="140" textAlign="Left" />
                  <ColumnDirective field="count" headerText="Count" width="80" textAlign="Left" />
                  <ColumnDirective field="avgElapsedMs" headerText="Time H:M:S" width="120" textAlign="Left" valueAccessor={avgElapsedHmsAccessor} />
                </ColumnsDirective>
                {/* Inject features into the grid dynamically */}
                <Inject services={[Page, Sort, Filter]} />
              </GridComponent>,
            )}
          </div>
        </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
          <div style={lboxStyle}>
            <h1>🎯 (HEAT STRESS RISK SCORE))</h1>
            <p>Composite score (-1 to 99) using multiple physiological and environmental factors</p>
            <AccumulationChartComponent width="100%" height={chartHeight}>
              <Inject services={[PieSeries]} />
              <AccumulationSeriesCollectionDirective>
                <AccumulationSeriesDirective
                  dataSource={chartData}
                  xName="x"
                  yName="y"
                  type="Pie"
                  innerRadius="50%"
                  explode
                  explodeIndex={0}
                  explodeOffset="10%"
                  dataLabel={{
                    visible: true,
                    position: 'Outside',
                    name: 'text',
                    format: 'p',
                  }}
                />
              </AccumulationSeriesCollectionDirective>
            </AccumulationChartComponent>
          </div>
        )}
        {selOrganization && selOrganization.length > 0 && (
          <div style={boxStyle}>
            <h1>⭕ (RISK SCORE GUIDE))</h1>
            {wrapAdaptiveGrid(
              <GridComponent
                dataSource={scoreCard}
                allowPaging
                pageSettings={pageSettings}
                allowTextWrap
                allowSorting
                allowFiltering
                width="100%"
                enableAdaptiveUI={isMobile}
                rowRenderingMode={zRenderMode}
              >
                <ColumnsDirective>
                  <ColumnDirective field="_id" headerText="ID" visible={false} width="120" isPrimaryKey textAlign="Left" />
                  <ColumnDirective field="score" headerText="TimScoree" width="100" textAlign="Left" />
                  <ColumnDirective field="desc" headerText="Description" width="150" textAlign="Left" />
                  <ColumnDirective field="action" headerText="Recommended Action" width="120" textAlign="Left" />
                </ColumnsDirective>
                {/* Inject features into the grid dynamically */}
                <Inject services={[Page, Sort, Filter]} />
              </GridComponent>,
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default Stats;
